import { useEffect, useState } from 'react';
import { getUserById, updateUser } from '../../services/users/editUserService.js';
import { isValidName, isValidUsername, isEmailValid, isPasswordValid, isDescriptionValid } from '../../utils/validations/userValidations.js';

const initialForm = {
    companyid: '', // opcional
    name: '',
    lastname: '',
    username: '',
    email: '',
    password: '',
    description: ''
};

export const useEditUser = (id) => {
    const [form, setForm] = useState(initialForm);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [validationErrors, setValidationErrors] = useState([]);

    useEffect(() => {
        const loadUser = async () => {
            try {
                const user = await getUserById(id);
                delete user.password;
                setForm({ ...initialForm, ...user, companyid: user.companyid ?? ''});
            } catch (err) {
                setError(
                    err.response?.status === 404
                        ? 'Usuario no encontrado.'
                        : 'Error al obtener los datos del usuario.'
                );
            }
        };

        loadUser();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const submit = async () => {
        // Limpieza previa
        setError('');
        setSuccess('');
        setValidationErrors([]);

        const { companyid, name, lastname, username, email, password, description } = form;
        
        // Validaciones frontend
        if (!isValidName(form.name) || !isValidName(form.lastname)) {
            setError('Los campos de nombre y apellidos, solo pueden contener letras, sin caracteres especiales.');
            return;
        }
        if (!isValidUsername(form.username)) {
            setError('El nombre de usuario solo pueden contener letras y números.');
            return;
        }
        if (!isEmailValid(form.email)){
            setError('El correo electrónico no es válido.');
            return;
        }
        if (form.password && !isPasswordValid(form.password)) {
            setError('La contraseña debe tener al menos 7 caracteres.');
            return;
        }
        if (!isDescriptionValid(form.description)) {
            setError('El campo comentarios no puede contener caracteres especiales.');
            return;
        }

        // Payload limpio
        const payload = {
            name,
            lastname,
            username,
            email,
            password,
            description
        };

        // Enviar password solo si fue modificado
        if (password?.trim()) {
            payload.password = password.trim();
        }

        // Enviar companyid solo si fue seleccionado
        if (companyid) {
            payload.companyid = Number(companyid);
        }

        // Si todo esta validado, procedimiento guardar
        try {
            await updateUser(id, payload);
            setSuccess('El registro del usuario ha sido actualizado exitosamente.');
            setValidationErrors([]);
        } catch (err) {
            // Validación del archivo: middleware/validator.js del backend
            if (err.response?.status === 400 && Array.isArray(err.response.data?.errors)) {
                setValidationErrors(err.response.data.errors);
                return;
            }
            // Error general
            setError(
                err.response?.data?.error || 
                err.response?.data?.message || 
                'Error al actualizar el usuario.'
            );
        }
    }

    const clearMessages = () => {
        setError('');
        setSuccess('');
        setValidationErrors([]);
    };

    return {
        form,
        error,
        success,
        validationErrors,
        handleChange,
        submit,
        clearMessages
    };
}